<template>
	<svg
		:alt="alt"
		xmlns="http://www.w3.org/2000/svg"
		width="14" height="10" viewBox="0 0 14 10"
	>
		<path d="M13.055 2.422a.723.723 0 0 1-.22.531L6.118 9.672a.723.723 0 0 1-.531.219.723.723 0 0 1-.531-.22l-3.89-3.89a.723.723 0 0 1-.22-.531.72.72 0 0 1 .22-.531l1.062-1.063a.723.723 0 0 1 .53-.219.72.72 0 0 1 .532.22L5.586 5.96 10.71.828a.723.723 0 0 1 .531-.219c.209 0 .386.073.531.22l1.063 1.062a.723.723 0 0 1 .219.53z" fill="#ffffff" fill-rule="evenodd"/>
	</svg>
</template>

<script>
export default {
	props: {
		alt: String
	}
};
</script>
